import Vue from 'vue'
import Router from 'vue-router'
import store from './store/store'
// Admin
import Admin from './views/admin/Admin'
import AdminLogin from './views/admin/AdminLogin'
import AdminResetPassword from "./views/admin/AdminResetPassword";
import AdminResetPasswordInit from "./views/admin/AdminResetPasswordInit";
//// Member
import Member from "./views/admin/Member/Member";
//// Hkiarace
import HkiaraceView from './views/admin/Hkiarace/HkiaraceView'
import Hkiarace from './views/admin/Hkiarace/Hkiarace'

import HkiaraceEventCategoryAdd from './views/admin/Hkiarace/HkiaraceEventCategoryAdd'
import HkiaraceEventCategoryDetail from './views/admin/Hkiarace/HkiaraceEventCategoryDetail'
import HkiaraceEventCategoryList from './components/hkiarace/HkiaraceEventCategoryList'

import AdminEvent from './views/admin/Hkiarace/Event'

import AdminPromotion from './views/admin/Hkiarace/Promotion'

import AdminCorporateVendor from './views/admin/Hkiarace/CorporateVendor'

import AdminSurvey from './views/admin/Hkiarace/Survey'

import HkiaraceHomePageSetting from './views/admin/Hkiarace/HkiaraceHomePageSetting'

import HkiaraceCheckIn from './views/admin/Hkiarace/HkiaraceCheckIn'

import HkiaraceReport from "./views/admin/Hkiarace/HkiaraceReport";
//// ACC Booking
import AccBookingView from "./views/admin/AccBooking/AccBookingView";
import AccBooking from "./views/admin/AccBooking/AccBooking";
import AccBookingDashboard from "./views/admin/AccBooking/AccBookingDashboard";
import AccBookingFacility from './views/admin/AccBooking/AccBookingFacility'
import AccEmailTemplateList from './components/acc_booking/EmailTemplateList';

import Settings from "./views/admin/Settings/Settings";
// Client
import Client from './views/client/Client'
import Home from './views/client/Home'

import Login from "./views/client/Login";
import EmailVerificationInit from "./views/client/EmailVerificationInit";
import EmailVerification from "./views/client/EmailVerification";
import DeviceVerification from "./views/client/DeviceVerification";
import MyAccount from "./views/client/MyAccount";
import ChangePassword from "./views/client/ChangePassword";
import ResetPassword from "./views/client/ResetPassword";
import ResetPasswordInit from "./views/client/ResetPasswordInit";
import NotificationList from "./views/client/NotificationList";
//// HKIARaCE
import IdVerification from "./views/client/Hkiarace/IdVerification";
import PreviewEvent from "./views/client/Hkiarace/PreviewEvent";
import Event from "./views/client/Hkiarace/Event";
import PastEventDetail from "./views/client/Hkiarace/PastEventDetail";
import PastEvent from "./views/client/Hkiarace/PastEvent";
import Promotion from "./views/client/Hkiarace/Promotion";
import Survey from "./views/client/Hkiarace/Survey";
import GlobalSurvey from "./views/client/GlobalSurvey";
import Facility from './views/client/AccBooking/Facility'
import FacilityInfo from "./views/client/AccBooking/FacilityInfo";
import FacilityReserve from "./views/client/AccBooking/FacilityReserve";
import BookingPreview from "./views/client/AccBooking/BookingPreview";
import BookingFailure from "./views/client/AccBooking/BookingFailure";
import BookingConfirm from "./views/client/AccBooking/BookingConfirm";
//// ACC
import Bookings from './views/client/AccBooking/Bookings'
import BookingList from "./views/client/AccBooking/BookingList";
import BookingDetail from "./views/client/AccBooking/BookingDetail";
import AccBookingEmailTemplateDetail from "./views/admin/AccBooking/AccBookingEmailTemplateDetail";
import AccGym from '@/views/admin/AccBooking/AccGym';
import AccPublicHoliday from './views/admin/AccBooking/AccPublicHoliday';
import AccPublicHolidayList from './views/admin/AccBooking/AccPublicHolidayList';
import Operator from "./views/admin/Operator/Operator";
//// Mobile
import Mobile from "./views/mobile/Mobile";
import MobileDeviceVerification from "./views/mobile/MobileDeviceVerification";
import MobileLogin from "./views/mobile/MobileLogin";
import AdminDeviceVerification from "./views/admin/AdminDeviceVerification";
import AccBookingReport from "./views/admin/AccBooking/AccBookingReport";
import AboutAcc from "./views/client/AboutAcc";
import Sitemap from "./views/client/Sitemap";
import EventPaymentConfirm from "./views/client/Hkiarace/EventPaymentConfirm";
import EventDetail from "./views/client/Hkiarace/EventDetail";

import GymPassSelect from "@/views/client/AccBooking/GymPassSelect";
import GymPassPreview from "@/views/client/AccBooking/GymPassPreview";
import AccGymSubscriptionDetail from "@/views/admin/AccBooking/AccGymSubscriptionDetail";
import GymPassDetail from "@/views/client/AccBooking/GymPassDetail";
import GymPassFailure from "@/views/client/AccBooking/GymPassFailure";
import GymPassConfirm from "@/views/client/AccBooking/GymPassConfirm";
import PointTopUp from "@/views/client/PointTopUp";
import HkiaraceRedeemWelcomeGift from "@/views/admin/Hkiarace/HkiaraceRedeemWelcomeGift";
import ShoppingCart from "@/views/client/ShoppingCart";
import PricingInfo from "@/views/client/PricingInfo";
import PointTopUpFailure from "@/views/client/AccBooking/PointTopUpFailure";
import Company from "@/views/admin/Hkiarace/Company";
import EmailTemplate from "@/views/admin/Hkiarace/EmailTemplate";
import Package from "@/views/admin/AccBooking/Package";
import PackageList from "@/views/client/AccBooking/PackageList";
import Booking from "@/views/admin/AccBooking/Booking";
import PackageDetail from "@/views/client/AccBooking/PackageDetail";
import ListSasv from "@/views/admin/Sasv/ListSasv";
import SasvView from "@/views/admin/Sasv/SasvView";
import SasvEmailTemplate from "@/views/admin/Sasv/SasvEmailTemplate";
import SasvRegister from "@/views/client/SasvRegister";
import SasvVerification from "@/views/client/Hkiarace/SasvVerification";
import SasvTnc from "@/views/admin/Sasv/SasvTnc";
import SasvDuplicate from "@/views/admin/Sasv/SasvDuplicate";
import GymReserve from "@/views/client/AccBooking/GymReserve";
import AccWhiteCard from "@/views/admin/AccBooking/AccWhiteCard";
import PaymentFailure from "@/views/client/Hkiarace/PaymentFailure";
import RecurrentBooking from "@/views/admin/AccBooking/RecurrentBooking.vue";
import PurchaseOrder from "@/views/admin/AccBooking/PurchaseOrder.vue";
import Invoice from "@/views/admin/AccBooking/Invoice.vue";
import InvoicePay from "@/views/client/AccBooking/InvoicePay.vue";
import InvoicePayFailure from "@/views/client/AccBooking/InvoicePayFailure.vue";
import InvoicePaySuccess from "@/views/client/AccBooking/InvoicePaySuccess.vue";
import DiscountCode from "@/views/admin/AccBooking/DiscountCode.vue";
import CouponGroup from "@/views/admin/AccBooking/CouponGroup.vue";

//// Pre-Reg
// import PreReg from "./views/pre-reg/PreReg";
// import PreRegHome from "./views/pre-reg/PreRegHome";


Vue.use(Router);

const router = new Router({
  scrollBehavior() {
    return {x: 0, y: 0}
  },
  routes: [
    {
      path: '/admin',
      name: 'admin',
      component: Admin,
      children: [
        {path: '', name: 'admin-login', component: AdminLogin},
        {path: 'verify_device', name: 'admin-device-verify', component: AdminDeviceVerification},
        {path: 'reset_password/:token', name: 'admin-reset-password', component: AdminResetPassword},
        {path: 'reset_password', name: 'admin-reset-password-init', component: AdminResetPasswordInit},
        {
          path: 'sasv',
          component: SasvView,
          children: [
            {path: '', name: 'sasv', component: ListSasv},
            {path: 'duplicate_names/', name: 'sasv-duplicate', component: SasvDuplicate},
            {path: 'email_template/', name: 'sasv-email-template', component: SasvEmailTemplate},
            {path: 'tnc/', name: 'sasv-tnc', component: SasvTnc},
          ]
        },
        {
          path: 'member',
          name: 'hkiarace-user',
          component: Member,
        },
        {
          path: 'operator',
          name: 'operator',
          component: Operator,
        },
        {
          path: 'hkiarace',
          component: HkiaraceView,
          children: [
            {
              path: '', name: 'hkiarace', component: Hkiarace,
              children: [
                {path: 'company/', name: 'hkiarace-company', component: Company},

                // {path: 'category/add/', name: 'hkiarace-event-category-add', component: HkiaraceEventCategoryAdd},
                // {path: 'category/:eventCategoryId', name: 'hkiarace-event-category-detail', component: HkiaraceEventCategoryDetail},
                // {path: 'category/', name: 'hkiarace-event-category', component: HkiaraceEventCategoryList},

                {path: 'event/', name: 'hkiarace-event', component: AdminEvent},

                {path: 'promotion/', name: 'hkiarace-promotion', component: AdminPromotion},

                {path: 'corporate_vendor/', name: 'hkiarace-corporate-vendor', component: AdminCorporateVendor},

                {path: 'email_template/', name: 'hkiarace-email-template', component: EmailTemplate},

                {path: 'survey/', name: 'hkiarace-survey', component: AdminSurvey},

                {path: 'home_page/', name: 'hkiarace-home-page', component: HkiaraceHomePageSetting},

                {path: 'check_in/', name: 'hkiarace-check-in', component: HkiaraceCheckIn},

                {path: 'redeem_welcome_gift/', name: 'hkiarace-redeem-welcome-gift', component: HkiaraceRedeemWelcomeGift},

                {path: 'report/', name: 'hkiarace-report', component: HkiaraceReport},
              ]
            },
          ],
        },
        {
          path: 'acc',
          component: AccBookingView,
          children: [
            {
              path: '', name: 'acc-booking', component: AccBooking,
              children: [
                {path: 'dashboard', name: 'acc-booking-dashboard', component: AccBookingDashboard},
                // {path: 'booking', name: 'acc-booking-booking', component: AccBookingBooking},
                {path: 'booking', name: 'acc-booking-booking', component: Booking},
                {path: 'recurrent_booking', name: 'acc-booking-recurrent-booking', component: RecurrentBooking},
                {path: 'purchase_order', name: 'acc-booking-purchase-order', component: PurchaseOrder},
                {path: 'invoice', name: 'acc-booking-invoice', component: Invoice},
                // {path: 'booking/:bookingId', name: 'acc-booking-booking-detail', component: AccBookingBookingDetail},
                {path: 'facility', name: 'acc-booking-facility', component: AccBookingFacility},

                {path: 'gym/', name: 'acc-gym', component: AccGym},
                {path: 'gym/subscription/:subscriptionId', name: 'acc-gym-subscription-detail', component: AccGymSubscriptionDetail},

                {path: 'package/', name: 'acc-package', component: Package},
                {path: 'discount_code/', name: 'acc-discount-code', component: DiscountCode},
                {path: 'coupon_group/', name: 'acc-coupon-group', component: CouponGroup},

                {path: 'email_template/', name: 'acc-email-template', component: AccEmailTemplateList},
                {path: 'email_template/:templateId', name: 'acc-booking-email-template-detail', component: AccBookingEmailTemplateDetail},

                {
                  path: 'public_holiday/', component: AccPublicHoliday,
                  children: [
                    {path: '', name: 'acc-public-holiday', component: AccPublicHolidayList},
                    // {path: ":holidayId", name: 'acc-public-holiday-edit'},
                  ],
                },

                {path: 'white_card/', name: 'acc-white-card', component: AccWhiteCard},

                {path: 'report/', name: 'acc-report', component: AccBookingReport},
              ],
            },
          ],
        },
        {path: 'settings', name: 'settings', component: Settings},
        // Catch-all route for non-existent admin paths - redirect to admin login
        {path: '*', redirect: {name: 'admin-login'}},
      ],
    },
    {
      path: '',
      component: Client,
      children: [
        {path: '', name: 'home', component: Home},

        // Common
        {path: 'about', name: 'about', component: AboutAcc},
        {path: 'login', name: 'login', component: Login},
        {path: 'register', name: 'register', component: SasvRegister},
        {path: 'init_email_verify', name: 'email-verify-init', component: EmailVerificationInit},
        {path: 'verify/:token', name: 'verify', component: EmailVerification},
        {path: 'verify_device', name: 'device-verify', component: DeviceVerification},

        {path: 'me', name: 'my-account', component: MyAccount},
        {path: 'change_password', name: 'change-password', component: ChangePassword},

        {path: 'reset_password/:token', name: 'reset-password', component: ResetPassword},
        {path: 'reset_password', name: 'reset-password-init', component: ResetPasswordInit},

        {path: 'notifications', name: 'notification-list', component: NotificationList},

        {path: 'payment_failure/:paymentRecordId', name: 'payment-failure', component: PaymentFailure},

        // Hkiarace
        {path: 'id_verify/:token', name: 'id-verify', component: IdVerification},
        {path: 'sasv_verify/:token?', name: 'sasv-verify', component: SasvVerification},

        {path: 'events/preview/:categoryId', name: 'hkiarace-event-preview', component: PreviewEvent},

        {path: 'events/after_payment/:paymentRecordId', name: 'event-payment-confirm', component: EventPaymentConfirm},
        {path: 'events/enrollment/:enrollmentId', name: 'my-event-detail', component: EventDetail},
        {path: 'events/:categoryId', name: 'event-list', component: Event},
        {path: 'past_event/:eventId', name: 'past-event-detail', component: PastEventDetail},
        {path: 'past_event', name: 'past-event', component: PastEvent},
        {path: 'promotion', name: 'promotion', component: Promotion},
        {path: 'pricing-info', name: 'pricing-info', component: PricingInfo},

        {path: 'survey/start/:surveyId', name: 'survey-start', component: GlobalSurvey},
        {path: 'survey/:responseId', name: 'survey', component: Survey},

        // ACC
        {
          path: 'facility', component: Facility,
          children: [
            {path: ':facilityTypeId', name: 'facility', component: FacilityInfo},
            {path: 'reserve/gym', name: 'gym-reserve', component: GymReserve},
            {path: 'reserve/:itemTypeId', name: 'facility-reserve', component: FacilityReserve},
            {path: 'preview/:bookingRecordId', name: 'booking-preview', component: BookingPreview},
            {path: 'failure/', name: 'booking-failure-without-id', component: BookingFailure},
            {path: 'failure/:bookingRecordId', name: 'booking-failure', component: BookingFailure},
            {path: 'confirm/:bookingRecordId', name: 'booking-confirm', component: BookingConfirm},
            {path: 'gym-pass/:facilityTypeId', name: 'gym-pass-select', component: GymPassSelect},
            {path: 'gym-pass/preview/:subscriptionId', name: 'gym-pass-preview', component: GymPassPreview},
            {path: 'gym-pass/failure/:subscriptionId', name: 'gym-pass-failure', component: GymPassFailure},
            {path: 'gym-pass/confirm/:subscriptionId', name: 'gym-pass-confirm', component: GymPassConfirm},
          ],
        },
        {
          path: 'bookings',
          component: Bookings,
          children: [
            {path: '', name: 'booking-list', component: BookingList},
            {path: ':bookingRecordId', name: 'booking-detail', component: BookingDetail},
          ],
        },
        {path: 'cart', name: 'shopping-cart', component: ShoppingCart},
        {path: 'gym-pass/:subscriptionId', name: 'gym-pass-detail', component: GymPassDetail},
        {path: 'top_up/init/', name: 'top-up-init', component: PointTopUp},
        {path: 'top_up/failure/', name: 'top-up-failure', component: PointTopUpFailure},
        // {path: '/tnc', name: 'tnc', component: Home},


        {path: 'package', name: 'package', component: PackageList},
        {path: 'package/:packageId', name: 'package-detail', component: PackageDetail},

        {path: 'invoice/pay/:invoiceId', name: 'invoice-pay', component: InvoicePay},
        {path: 'invoice/failure/:invoiceId', name: 'invoice-pay-failure', component: InvoicePayFailure},
        {path: 'invoice/success/:invoiceId', name: 'invoice-pay-success', component: InvoicePaySuccess},

        {path: '/sitemap', name: 'sitemap', component: Sitemap},
      ],
    },
    // ACA
    {
      path: '/mobile',
      component: Mobile,
      children: [
        {path: '', name: 'mobile-login', component: MobileLogin},
        {path: ':username', name: 'mobile-login-with-username', component: MobileLogin},
        {path: 'init_email_verify', name: 'mobile-email-verify-init', component: EmailVerificationInit},
        {path: 'verify_device', name: 'mobile-device-verify', component: MobileDeviceVerification},
        {path: 'reset_password', name: 'mobile-reset-password-init', component: ResetPasswordInit},
        {path: 'id_verify', name: 'mobile-id-verify', component: IdVerification},
        {path: 'success/:jwt', name: 'mobile-login-success'},
      ],
    }

    // {
    //     path: '',
    //     component: PreReg,
    //     children: [
    //         {path: '', name: 'home', component: PreRegHome},
    //
    //         {path: 'login', name: 'login', component: Login},
    //         {path: 'register', name: 'register', component: Register},
    //         {path: 'init_email_verify', name: 'email-verify-init', component: EmailVerificationInit},
    //         {path: 'verify/:token', name: 'verify', component: EmailVerification},
    //         {path: 'id_verify/', name: 'id-verify', component: IdVerification},
    //         {path: 'verify_device', name: 'device-verify', component: DeviceVerification},
    //
    //         {path: 'me', name: 'my-account', component: MyAccount},
    //         {path: 'change_password', name: 'change-password', component: ChangePassword},
    //
    //         {path: 'reset_password/:token', name: 'reset-password', component: ResetPassword},
    //         {path: 'reset_password', name: 'reset-password-init', component: ResetPasswordInit},
    //
    //         {path: 'promotion', name: 'promotion', component: Promotion},
    //     ],
    // },
  ]
})

router.beforeEach(async (to, from, next) => {
  // Define routes that don't require authentication
  const publicAdminRoutes = ['admin-login', 'admin-reset-password', 'admin-reset-password-init', 'admin-device-verify'];

  // Check if route is under /admin (except public routes)
  if (to.path.startsWith('/admin') && !publicAdminRoutes.includes(to.name)) {
    // Ensure authentication check has been performed
    await store.dispatch('ensureAuthCheck', {v: null});
    
    const user = store.state.user;
    const isAuthenticated = user && user.id;
    const isAdmin = user && user.type && user.type === 369;
    const isOperator = user && user.type && user.type === 100;
    
    if (!isAuthenticated) {
      // Not logged in - redirect to admin login
      next({ name: 'admin-login' });
    } else if (!isAdmin && !isOperator) {
      // Logged in but not an admin/operator - clear local state and redirect
      // Don't call API logout here since we don't have Vue instance
      store.commit('signOut');
      next({ name: 'admin-login' });
    } else {
      // Authenticated and is admin/operator - allow access
      next();
    }
  } 

  else {
    // All other routes - allow access
    next();
  }

});

export default router;